"use client";
import {
  Accordion,
  Button,
  Select,
  Tooltip,
  useComputedColorScheme,
} from "@mantine/core";
import Link from "next/link";
import { useRouter } from "next/navigation";
import classes from "./ResourceTableButtons.module.css";

export interface ResourceButtonProps {
  documentId: string;
  title: string;
}
export default function ResourceTableButtons({
  buttons,
}: {
  buttons: ResourceButtonProps[];
}) {
  const colorScheme = useComputedColorScheme("light");
  const router = useRouter();
  const validButtons = buttons.filter(
    (b) => typeof b.documentId === "string" && b.documentId.length > 0
  );

  return (
    <>
      <div className={classes.desktopOnly}>
        <Accordion
          defaultValue={null}
          classNames={{
            control: classes.accordionControl,
            item: classes.accordionItem,
          }}
        >
          <Accordion.Item value="quick-jump">
            <Accordion.Control>Quick Jump on Page</Accordion.Control>
            <Accordion.Panel>
              <div className={classes.gridContainer}>
                {validButtons.map((button) => (
                  <Tooltip
                    key={button.documentId}
                    label={button.title}
                    position="top"
                    withArrow
                    openDelay={250}
                  >
                    <Button
                      component={Link}
                      href={`#${button.documentId}`}
                      color={colorScheme === "dark" ? "dark" : "darkblue"}
                      size="xs"
                      classNames={{
                        root: classes.buttonRoot,
                        label: classes.buttonLabel,
                      }}
                    >
                      {button.title}
                    </Button>
                  </Tooltip>
                ))}
              </div>
            </Accordion.Panel>
          </Accordion.Item>
        </Accordion>
      </div>

      <div className={classes.mobileOnly}>
        <Select
          size="md"
          placeholder="Quick Jump on Page"
          data={validButtons.map((b) => ({
            value: b.documentId,
            label: b.title,
          }))}
          onChange={(val) => {
            if (val) router.push(`#${val}`);
          }}
          mx="auto"
          mb={32}
          maxDropdownHeight={400}
          classNames={{
            input: classes.input,
            dropdown: classes.dropdown,
            option: classes.selectItem,
          }}
        />
      </div>
    </>
  );
}
